<template>
  <div class="shine" v-if="loadingState === LoadingState.LOADING"></div>
  <div class="text-secondary text-small-1" v-else-if="loadingState === LoadingState.ERRORED">
    Something went wrong while fetching checkin history.
    <br />
    <link-button class="text-small-1 px-0" @click="$emit('fetch')" underline>Try again</link-button>
  </div>
  <div v-else-if="checkinsToShow">
    <div v-if="checkinsToShow.length === 0">
      There are no checkins yet.
    </div>
    <ul class="list-unstyled text-small-1 mb-0" v-else>
      <li class="d-flex py-1" v-for="checkinEvent in checkinsToShow" :key="checkinEvent.id">
        <div class="date text-secondary">{{ formatDate(checkinEvent.createdAt) }}</div>
        <div class="checkin-value px-2" :title="measurementText(checkinEvent.checkin.newCurrent)">
          {{ measurementText(checkinEvent.checkin.newCurrent, 'compact') }}
        </div>
        <div class="text-nowrap text-secondary status">
          {{ krStatusText(checkinEvent.checkin.newStatus) }}
        </div>
      </li>
      <link-button
        class="px-0 text-small-1"
        @click="showAll = true"
        underline
        v-if="checkinsToShow && !showAll && checkinHistory.length > defaultListSize"
        >More
      </link-button>
    </ul>
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton.vue'
import { LoadingState } from '@/constants/common'
import { formatHyphenatedString, krMeasurementText } from '@/goalUtils'
import { formatDate } from '@/utils/formatDate'

/**
 * This shows the history of KR checkins in a list view
 */
export default {
  name: 'CheckInHistoryList',
  props: {
    kr: Object,
    /**
     * This denotes the loading state of the checkinStory. It is used for handling loading/error state.
     */
    loadingState: LoadingState,
    /**
     * This should be the array of checkin events
     */
    checkinHistory: Array
  },
  components: { LinkButton },
  data() {
    return {
      LoadingState,
      showAll: false,
      defaultListSize: 3
    }
  },
  computed: {
    checkinsToShow() {
      if (this.showAll) {
        return this.checkinHistory
      } else {
        return this.checkinHistory?.slice(0, this.defaultListSize)
      }
    }
  },
  methods: {
    krStatusText: formatHyphenatedString,
    measurementText(value, format) {
      return krMeasurementText(this.kr.measureBy, value, format)
    },
    formatDate
  }
}
</script>

<style lang="scss" scoped>
.shine {
  height: 12px;
  width: 100px;
}

.checkin-value {
  flex: 1 0 0;
}

.date {
  flex-basis: 85px;
  flex-shrink: 0;
}

.status {
  flex-basis: 60px;
  flex-shrink: 0;
}
</style>
